import { render, staticRenderFns } from "./McaDetail.vue?vue&type=template&id=2d8c2f52&scoped=true"
import script from "./McaDetail.vue?vue&type=script&lang=ts"
export * from "./McaDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c2f52",
  null
  
)

export default component.exports